import { StatisticShopContext } from 'sections/statistics/pages/ShopStatistic/contexts/StatisticShopContext'
import { useContext } from 'react'

export function useStatisticShop() {
	return useContext(StatisticShopContext)
}
